"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PrepaidPaymentStrategy = _interopRequireDefault(require("./PrepaidPaymentStrategy"));
var _ConcurrencyManager = _interopRequireDefault(require("../ConcurrencyManager"));
var _PaidCallPaymentStrategy = _interopRequireDefault(require("./PaidCallPaymentStrategy"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class DefaultPaymentStrategy {
  /**
   * Initializing the payment strategy
   * @param {number} concurrentCalls
   */
  constructor(concurrentCalls = 1) {
    this._concurrentCalls = concurrentCalls;
  }

  /**
   * map the metadata for the gRPC call
   * @param {BaseServiceClient} serviceClient
   * @returns {Promise<({'snet-payment-type': string}|{'snet-payment-channel-id': string}|{'snet-payment-channel-nonce': string}|{'snet-payment-channel-amount': string}|{'snet-payment-channel-signature-bin': string.base64})[]>}
   */
  async getPaymentMetadata(serviceClient) {
    let metadata;
    if (serviceClient.concurrencyFlag) {
      const concurrencyManager = new _ConcurrencyManager.default(this._concurrentCalls, serviceClient);
      const paymentStrategy = new _PrepaidPaymentStrategy.default(serviceClient, concurrencyManager);
      metadata = await paymentStrategy.getPaymentMetadata();
    } else {
      const paymentStrategy = new _PaidCallPaymentStrategy.default(serviceClient);
      metadata = await paymentStrategy.getPaymentMetadata();
    }
    return metadata;
  }
}
var _default = exports.default = DefaultPaymentStrategy;